// DUPLICATED — keep in sync with src/webform/components/Header/header.styled.ts (monolith).
// Can't be shared via path alias: a file under src/ resolves styled-components@5, while
// this workspace needs styled-components@6. Mirror every change on both sides until the
// monolith webform is decommissioned.
import {lightBorder, staticBg} from "config/themeV2";
import styled from "styled-components";

export const Background = styled.div`
    z-index: 10;
    background-color: ${staticBg["active-key-light"]};
    position: sticky;
    top: 0;
    left: 0;
    height: 112px;

    @media (max-width: 500px) {
        height: 80px;
    }
`;

export const Wrapper = styled.div`
    border-left: 1px solid ${lightBorder["neutral-secondary"]};
    border-right: 1px solid ${lightBorder["neutral-secondary"]};
    max-width: 506px;
    width: 100%;
    height: 100%;
    margin: auto;

    @media (max-width: 500px) {
        border: 0;
    }
`;

export const Logo = styled.img`
    padding: 40px 24px;
    max-width: 100%;
    max-height: 100%;
    display: block;

    @media (max-width: 500px) {
        padding: 24px 16px;
    }
`;
